export default __webpack_public_path__ + "static/media/icon-route-buffer-time.4adfe4b9.svg";